import React from 'react';
import { observer } from 'mobx-react-lite';

import { Stripboard } from '../../../app/entities/stripboard';
import { BaseBlock } from './styled-strips';
import { AddStripMenu } from './add-strip-menu';
import { HeaderData } from './shot-strip.mobile';
import { CellContent, CellLabel } from '../../shootingdays/components/styled-mobile-table';
import { getRenderedTime } from '../../../lib/utils/Convertor';
import { minutesFormatter } from '../../../lib/time-formatters';

import type { BannerStrip } from '../../../app/entities/strip';
import type { Property } from '../../../app/entities/property';

import styles from './break-strip.mobile.module.scss';
interface MobileBreakStripProps {
  strip: BannerStrip;
  stripboard: Stripboard;
  properties?: Property[];
}

export const MobileBreakStrip: React.FC<MobileBreakStripProps> = observer(
  ({ stripboard, strip, properties }) => {
    const showEstTime = properties?.some((property) => property.key === 'estimatedTime');
    const showTime = properties?.some((property) => property.key === 'startTime');

    return (
      <div className={styles['container']}>
        <BaseBlock className={styles['block']}>
          <span className={styles['block-text']}>{strip.data.text}</span>
        </BaseBlock>

        <div className={styles['header-data-wrapper']}>
          {showTime && (
            <HeaderData>
              <CellLabel>Time</CellLabel>

              <CellContent>{getRenderedTime(strip.startTime)}</CellContent>
            </HeaderData>
          )}

          {showEstTime && (
            <HeaderData>
              <CellLabel>Est. Time</CellLabel>

              <CellContent>{minutesFormatter(strip.data.estimatedTime || 0)}</CellContent>
            </HeaderData>
          )}
        </div>

        <AddStripMenu
          stripId={strip._id}
          projectId={stripboard.projectId}
          position={strip.position}
          isDark
          stripType="banner"
        />
      </div>
    );
  },
);
